import { Image, UIText1, UIText2 } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import React from 'react';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';

import * as styles from './styles.css';

export const ClientTypeToggle: React.FC<{
  activeText: string;
  activeIconX1: string;
  activeIconX2: string;
  inactiveText: string;
  inactiveIconX1: string;
  inactiveIconX2: string;
  inactiveLinkHref: string;
  onLinkClick(): void;
}> = props => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const TextComponent = isMobile ? UIText2 : UIText1;
  const imageSize = isMobile ? 24 : 40;

  return (
    <div className={cn(styles['toggle'], styles[deviceType])}>
      <div className={cn(styles['toggle-button'], styles['toggle-button-active'], styles[deviceType])}>
        <Image
          width={imageSize}
          height={imageSize}
          sources={[{ media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: props.activeIconX2 }, { srcset: props.activeIconX1 }]}
          src={props.activeIconX1}
          loading="lazy"
        />
        <TextComponent whiteSpace={isMobile ? undefined : 'nowrap'}>{props.activeText}</TextComponent>
      </div>
      <a
        className={cn(styles['toggle-button'], styles[deviceType], styles['toggle-button-inactive'])}
        href={props.inactiveLinkHref}
        onClick={props.onLinkClick}
      >
        <Image
          width={imageSize}
          height={imageSize}
          sources={[
            { media: X2_IMAGE_SIZE_MEDIA_QUERY, srcset: props.inactiveIconX2 },
            { srcset: props.inactiveIconX1 },
          ]}
          src={props.activeIconX1}
          loading="lazy"
        />
        <TextComponent whiteSpace={isMobile ? undefined : 'nowrap'}>{props.inactiveText}</TextComponent>
      </a>
    </div>
  );
};
